// Type-safe analytics track() (web) — каталог `@studyhub/shared/analytics`.
// Те же события, что server: единый source of truth. Валидация Zod-схемой
// (runtime) + типизация (compile-time). Большинство product-событий шлёт
// именно клиент (server — только критичные: signup/subscription/payment).
import { type EventName, type EventProps, events } from "@studyhub/shared/analytics";
import { getPostHog, isPostHogEnabled } from "./posthog-client";

/**
 * Отправить product-событие. Валидирует props схемой каталога; дроп при
 * провале (fire-and-forget — track не ломает UI).
 */
export function track<N extends EventName>(event: N, props: EventProps<N>): void {
	// Согласие на аналитику проверяет сам `isPostHogEnabled()` (OXEM-604): отзыв
	// — это «прекратить обработку», а не «учесть в следующий раз».
	if (!isPostHogEnabled()) return;
	const parsed = events[event].safeParse(props);
	if (!parsed.success) {
		if (import.meta.env.DEV) {
			console.warn(`[analytics] invalid props for "${event}"`, parsed.error.issues);
		}
		return;
	}
	try {
		getPostHog()?.capture(event, parsed.data as Record<string, unknown>);
	} catch {
		// игнор
	}
}
